import { render, staticRenderFns } from "./RuleBuilderV3.vue?vue&type=template&id=bb2155f6&scoped=true"
import script from "./RuleBuilderV3.vue?vue&type=script&lang=js"
export * from "./RuleBuilderV3.vue?vue&type=script&lang=js"
import style0 from "./RuleBuilderV3.vue?vue&type=style&index=0&id=bb2155f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb2155f6",
  null
  
)

export default component.exports